// extracted by mini-css-extract-plugin
module.exports = {"partyRow":"ConferenceActive_partyRow_1f791"};